import {
    SWITCH_FLAG,
    Y_WEBSOCK_CONNECTED,
    Y_WEBSOCK_DISCONNECTED,
    Y_WEBSOCK_DUPLICATED,
} from '../actions/yWebsockAction';

const Y_WEBSOCKetInitialState  = {
    isConnected: false,
    isDuplicated: false,
    flag:false,
};

const yWebsock = (state = Y_WEBSOCKetInitialState, action) => {
    switch (action.type) {
        case Y_WEBSOCK_CONNECTED:
            return Object.assign({}, state, {
                isConnected: true,
            });
        case Y_WEBSOCK_DISCONNECTED:
            return Object.assign({}, state, {
                isConnected: false,
            });
        case Y_WEBSOCK_DUPLICATED:
            return Object.assign({}, state, {
                isDuplicated: true,
            });
        case SWITCH_FLAG:
            return Object.assign({}, state, {
                flag: (null === state.flag || undefined === state.flag) ? false : !state.flag,
            });

        default:
            return state;
    }
};

export default yWebsock;
